import { render, staticRenderFns } from "./ShareStrategyPanel.vue?vue&type=template&id=63be39a6&scoped=true"
import script from "./ShareStrategyPanel.vue?vue&type=script&lang=js"
export * from "./ShareStrategyPanel.vue?vue&type=script&lang=js"
import style0 from "./ShareStrategyPanel.vue?vue&type=style&index=0&id=63be39a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be39a6",
  null
  
)

export default component.exports